import { environment as envStaging } from './environment.staging';

export const environment = {
  ...envStaging,
  production: true,
  BASE_BACKEND_URL: 'https://backend.crazycall.com',
  CALL_PANEL_URL: 'https://call.crazycall.com',
  SSO_URL: 'https://sso.crazycall.com',
  WEB_CALL_SCRIPT_URL: 'https://crazy-website-widget.crazycall.com/prod2/widget.js',
  IFRAME_ADDRESS: 'https://crazy-website-widget.crazycall.com/',
  WEB_CALL_BACKEND_CONFIGURATOR_URL: 'https://leadgeneration.crazycall.com/',
  CRAZYCALL_BACKEND_URL: 'https://backend.crazycall.com',
  APP_ID: 'crazycall-prod2',
  INTERNATIONALIZATION_URL:
    'https://s3-eu-west-1.amazonaws.com/crazycall-production2-internationalization/web-frontend/',
  TYPEFORM_URL: 'https://andrzejmuzaj.typeform.com/to/lLDMQM',
  LEAD_GENERATION_ENV: 'prod2',
  CHANNELS_URL: 'https://my.channels.app',
  BACKEND_CHANNELS_URL: 'https://backend.channels.app',
  SHOPER_CONNECT_URL: 'https://app.shoperconnect.pl',
  CHROME_STORE_WIDGET_ID: 'cnlibahlccceecnjljbjhbpmkggfekkn'
};
